import { GridPinnedColumns } from '@mui/x-data-grid-pro';
import * as React from 'react';

interface ColumnModelI {
  regions: {
    columnModel: {
      name?: boolean;
      country?: boolean;
      states?: boolean;
      createdAt?: boolean;
      editedAt?: boolean;
      isActive?: boolean;
    };
    pinnedColumns?: GridPinnedColumns;
  };
  resources: {
    columnModel: {
      name?: boolean;
      integrationGUID?: boolean;
      role?: boolean;
      team?: boolean;
      state?: boolean;
      isActive?: boolean;
    };
    pinnedColumns?: GridPinnedColumns;
  };
  roles: {
    columnModel: {
      name?: boolean;
      activeUsers?: boolean;
      rightsCount?: boolean;
      createdAt?: boolean;
    };
    pinnedColumns?: GridPinnedColumns;
  };
  taskGroups: {
    columnModel: {
      name?: boolean;
      description?: boolean;
      dispatchMethod?: boolean;
      createdBy?: boolean;
      createdDate?: boolean;
      lastEditedBy?: boolean;
      lastEditedDate?: boolean;
    };
    pinnedColumns?: GridPinnedColumns;
  };
  taskTemplates: {
    columnModel: {
      externalId?: boolean;
      name?: boolean;
      description?: boolean;
      dateCreated?: boolean;
      dateEdited?: boolean;
      timesUsed?: boolean;
      isActive?: boolean;
    };
    pinnedColumns?: GridPinnedColumns;
  };
  tasks: {
    columnModel: {
      claimNumber?: boolean;
      insuredName?: boolean;
      lossCity?: boolean;
      lossState?: boolean;
      lossCounty?: boolean;
      dateOfLoss?: boolean;
      appointment?: boolean;
      assignedResourceId?: boolean;
      targetQueue?: boolean;
    };
    pinnedColumns?: GridPinnedColumns;
  };
  users: {
    columnModel: {
      name?: boolean;
      externalId?: boolean;
      email?: boolean;
      roleId?: boolean;
      createdAt?: boolean;
      isActive?: boolean;
    };
    pinnedColumns?: GridPinnedColumns;
  };
}

interface ColumnContextI {
  tableState: ColumnModelI;
  setTableState: React.Dispatch<React.SetStateAction<ColumnModelI>>;
}

export const TableContext = React.createContext<ColumnContextI | undefined>(
  undefined
);

function TableProvider({ children }: { children: React.ReactChild }) {
  const initialState: unknown = Object.fromEntries(
    [
      'regions',
      'resources',
      'roles',
      'taskGroups',
      'taskTemplates',
      'tasks',
      'users',
    ].map((name) => [
      name,
      {
        columnModel: {},
        pinnedColumns: {
          left: [],
          right: [],
        },
      },
    ])
  );
  const [tableState, setTableState] = React.useState<ColumnModelI>(
    initialState as ColumnModelI
  );

  const value = { tableState, setTableState };

  return (
    <TableContext.Provider value={value}>{children}</TableContext.Provider>
  );
}

function useTableState() {
  const context = React.useContext(TableContext);
  if (context === undefined) {
    throw new Error('useTableState must be used within a Table Model Provider');
  }
  return context;
}

export { TableProvider, useTableState };
